// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Opponents__container-b84b4c {
  --opponents-list-max-height: 100vh;
  flex-shrink: 0;
  padding: 8px 0 0 8px;
  box-sizing: border-box;
  max-height: var(--opponents-list-max-height);
  overflow: hidden;
}

.Opponents__opponents-exit-efb728 {
  max-height: var(--opponents-list-max-height);
}

.Opponents__opponents-exit-active-b9ea47 {
  max-height: 0;
  transition: max-height 100ms ease-out;
}

.Opponents__opponents-enter-f64ecd {
  max-height: 0;
}

.Opponents__opponents-enter-active-f47c58 {
  max-height: var(--opponents-list-max-height);
  transition: max-height 100ms ease-out;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/CompactCallView/Shared/SpeakerVideo/Opponents/Opponents.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kCAAA;EAEA,cAAA;EACA,oBAAA;EACA,sBAAA;EACA,4CAAA;EACA,gBAAA;AAAF;;AAGA;EACE,4CAAA;AAAF;;AAGA;EACE,aAAA;EACA,qCAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,4CAAA;EACA,qCAAA;AAAF","sourcesContent":[".container {\n  --opponents-list-max-height: 100vh;\n\n  flex-shrink: 0;\n  padding: 8px 0 0 8px;\n  box-sizing: border-box;\n  max-height: var(--opponents-list-max-height);\n  overflow: hidden;\n}\n\n.opponents-exit {\n  max-height: var(--opponents-list-max-height);\n}\n\n.opponents-exit-active {\n  max-height: 0;\n  transition: max-height 100ms ease-out;\n}\n\n.opponents-enter {\n  max-height: 0;\n}\n\n.opponents-enter-active {\n  max-height: var(--opponents-list-max-height);\n  transition: max-height 100ms ease-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Opponents__container-b84b4c`,
	"opponents-exit": `Opponents__opponents-exit-efb728`,
	"opponentsExit": `Opponents__opponents-exit-efb728`,
	"opponents-exit-active": `Opponents__opponents-exit-active-b9ea47`,
	"opponentsExitActive": `Opponents__opponents-exit-active-b9ea47`,
	"opponents-enter": `Opponents__opponents-enter-f64ecd`,
	"opponentsEnter": `Opponents__opponents-enter-f64ecd`,
	"opponents-enter-active": `Opponents__opponents-enter-active-f47c58`,
	"opponentsEnterActive": `Opponents__opponents-enter-active-f47c58`
};
module.exports = ___CSS_LOADER_EXPORT___;
